import request from '@/utils/request';

// 订单售后(后台)
export const orderRefund = (data: any): any =>
  request({
    url: '/order/orderrefund',
    data
  })


// 查看售后详情(后台)
export const getBackendOrderRefundInfo = (data: any): any =>
  request({
    url: '/order/backend/refund/info',
    data
  })

// 补充售后信息
export const setOrderRefundDetail = (data: any): any =>
  request({
    url: '/order/set/refund/detail',
    data
  })

// 售后确认/取消(后台)
export const checkOrderRefund = (data: any): any =>
  request({
    url: '/order/checkorderrefund',
    data
  })

// 订单售后详情(后台)
export const getOrderAfterDetail = (data: any): any =>
  request({
    url: '/order/after/detail',
    data
  })

// 获取供应商售后统计
export const getProviderAfterStatistics = (data: any): any =>
  request({
    url: '/provider/after/statistics',
    data
  })

// 分销员售后统计
export const getAgentRefundStatistics = (data: any): any =>
  request({
    url: '/agent/refund/statistics',
    data
  })

// 分销员售后统计明细
export const getAgentRefundOrderList = (data: any): any =>
  request({
    url: '/agent/refund/order/list',
    data
  })

// 分销员售后统计明细确认
export const oprAgentRefund = (data: any): any =>
  request({
    url: '/agent/refund/opr',
    data
  })

// 供应商_售后统计_查看详情
export const getProviderAfterInfo = (data: any) =>
  request({
    url: '/provider/after/info',
    data
  })





// 售后单管理
export const orderSupportlist = (data: any): any =>
  request({
    url: '/pc/orderSupport/list',
    data
})
// 售后单管理 确认收货
export const confirmReceiveGoods = (data: any): any =>
  request({
    url: '/pc/orderSupport/confirmReceiveGoods',
    data
})

// 售后单详情
export const orderSupportdetail = (data: any): any =>
  request({
    url: '/pc/orderSupport/detail',
    data
})
// 售后单审核通过
export const orderSupportcheckPass = (data: any): any =>
  request({
    url: '/pc/orderSupport/checkPass',
    data
})
// 售后单审核驳回
export const orderSupportcheckReject = (data: any): any =>
  request({
    url: '/pc/orderSupport/checkReject',
    data
})
// 售后单填写物流
export const orderSupportsendGoods = (data: any): any =>
  request({
    url: '/pc/orderSupport/sendGoods',
    data
})

// 售售后单-修改退款金额
export const orderSupportmodifyRealRefundMoney = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifyRealRefundMoney',
    data
})
// 售后单-修改收款账户
export const orderSupportmodifyAlipayAccount = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifyAlipayAccount',
    data
})
// 售后单-退款
export const orderSupportrefund = (data: any): any =>
  request({
    url: '/pc/orderSupport/refund',
    data
})
// 售后单-关闭
export const orderSupportclose = (data: any): any =>
  request({
    url: '/pc/orderSupport/close',
    data
})
// 售后单-修改系统备注（新加）
export const orderSupportmodifySystemRemark = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifySystemRemark',
    data
})
// 获取公司直属授权通过的分销员
export const memberdirectCompanyMemberList = (data: any): any =>
  request({
    url: '/pc/member/directCompanyMemberList',
    data
})
// 获取员工负责售后的团队
export const employeeResponsibleTeamlist = (data: any): any =>
  request({
    url: '/pc/employeeResponsibleTeam/list',
    data
})
// 保存员工负责售后的团队
export const employeeResponsibleTeamsave = (data: any): any =>
  request({
    url: '/pc/employeeResponsibleTeam/save',
    data
})




// 寄回物流单号错误-提醒用户
export const orderSupporterrorReturnExpressNoAlert = (data: any): any =>
  request({
    url: '/pc/orderSupport/errorReturnExpressNoAlert',
    data
})


// 售后单管理 提醒列表
export const orderSupportremindList = (data: any): any =>
  request({
    url: '/pc/orderSupport/remindList',
    data
})


// 售后单-修改退款运费金额(运费险)
export const orderSupportmodifyReturnFreightInsuranceMoney = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifyReturnFreightInsuranceMoney',
    data
})

// 售后单-代客户确认收货 
export const orderSupportinsteadCustomerConfirmReceiveGoods = (data: any): any =>
  request({
    url: '/pc/orderSupport/insteadCustomerConfirmReceiveGoods',
    data

})


// 售后单返回待审核
export const orderSupportreturnCheck = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnCheck',
    data
})

// 售后单审核人员
export const orderSupportemployeelist = (data: any): any =>
  request({
    url: '/pc/orderSupport/employee/list',
    data
})
// 售后情况
export const orderSupportoverview = (data: any): any =>
  request({
    url: '/pc/orderSupport/overview',
    data
})
// 售后单寄回物流修改
export const orderSupportreturnExpressedit = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnExpress/edit',
    data
})

// 售后单-仅退款-修改收货状态
export const orderSupportmodifyProductState = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifyProductState',
    data
})


// 售后单买家已寄出列表
export const orderSupportreturnList = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnList',
    data
})
// 售后单寄回物流初始化
export const orderSupportreturnExpressinit = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnExpress/init',
    data
})
// 售后单寄出物流修改
export const orderSupportsendGoodsedit = (data: any): any =>
  request({
    url: '/pc/orderSupport/sendGoods/edit',
    data
})
// 售后单寄回物流填写
export const orderSupportreturnExpresswrite = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnExpress/write',
    data
})
// 售后单-修改系统备注记录
export const orderSupportmodifySystemRemarkRecordList = (data: any): any =>
  request({
    url: '/pc/orderSupport/modifySystemRemarkRecordList',
    data
})
// 退换无忧赔付统计
export const freightCompensationStatisList = (data: any): any =>
  request({
    url: '/pc/orderSupport/freightCompensationStatisList',
    data
})
// 退换无忧-恢复购买
export const restoreBuyFreightInsurance = (data: any): any =>
  request({
    url: '/pc/orderSupport/restoreBuyFreightInsurance',
    data
})
//修改售后地址
export const orderSupportreturnAddressedit = (data: any): any =>
  request({
    url: '/pc/orderSupport/returnAddress/edit',
    data
})